<template>
  <card class="stacked-form">
    <form @submit.prevent="submit">
      <div class="row">
        <div class="col-sm-5">
          <legend>Stammdaten</legend>
          <fg-input label="Name"
            type="text"
            v-model="supplier.name"
            :error="valErrors['name'] ? valErrors['name'][0] : null"
          />
          <fg-input label="Kundennummer"
            type="text"
            v-model="supplier.customer_number"
            :error="valErrors['customer_number'] ? valErrors['customer_number'][0] : null"
          />
          <fg-input label="E-Mail Adresse"
            type="email"
            v-model="supplier.email"
            :error="valErrors['email'] ? valErrors['email'][0] : null"
          />
          <fg-input label="Telefonnummer"
            type="text"
            v-model="supplier.phone"
            :error="valErrors['phone'] ? valErrors['phone'][0] : null"
          />
          <fg-input label="Straße"
            type="text"
            v-model="supplier.street"
            :error="valErrors['street'] ? valErrors['street'][0] : null"
          />
          <div class="row">
            <div class="col-sm-3">
              <fg-input label="PLZ"
                type="text"
                v-model="supplier.zip"
                :error="valErrors['zip'] ? valErrors['zip'][0] : null"
              />
            </div>
            <div class="col-sm-9">
              <fg-input label="Ort"
                type="text"
                v-model="supplier.place"
                :error="valErrors['place'] ? valErrors['place'][0] : null"
              />
            </div>
          </div>
          <div class="form-group has-label">
            <label>Land</label>
            <multiselect v-model="supplier.country"
              :options="countries"
            />
          </div>
          <div class="row">
            <div class="col-sm-9">
              <fg-input label="IBAN"
                type="text"
                v-model="supplier.iban"
                :error="valErrors['iban'] ? valErrors['iban'][0] : null"
              />
            </div>
            <div class="col-sm-3">
              <fg-input label="BIC"
                type="text"
                v-model="supplier.bic"
                :error="valErrors['bic'] ? valErrors['bic'][0] : null"
              />
            </div>
          </div>
          <fg-input label="Webshop"
            type="text"
            v-model="supplier.webshop"
            :error="valErrors['webshop'] ? valErrors['webshop'][0] : null"
          />
          <fg-input label="Homepage"
            type="text"
            v-model="supplier.homepage"
            :error="valErrors['homepage'] ? valErrors['homepage'][0] : null"
          />
          <fg-input label="Username"
            type="text"
            v-model="supplier.username"
            :error="valErrors['username'] ? valErrors['username'][0] : null"
          />
          <fg-input label="Passwort"
            type="text"
            v-model="supplier.password"
            :error="valErrors['password'] ? valErrors['password'][0] : null"
          />

          <fg-input label="Kommentar">
            <textarea class="form-control" v-model="supplier.comment" rows="3"></textarea>
          </fg-input>
        </div>
        <div class="col-sm-6 offset-sm-1">
          <legend>Kategorie & Tags</legend>
          <div class="form-group has-label">
            <label>Kategorie</label>
            <multiselect v-model="supplier.category"
              :options="supplierCategories"
              track-by="id"
              label="name"
              :allow-empty="false"
            />
          </div>
          <div class="form-group has-label">
            <label>Tags</label>
            <multiselect v-model="supplier.tags"
              :options="supplierTags"
              track-by="id"
              label="name"
              :multiple="true"
            />
          </div>
          <legend>Zahlungsbedingungen</legend>
          <div class="form-group has-label">
            <label>Zahlungskondition</label>
            <div class="d-flex align-items-center">
              <span>Binnen</span>
              <input type="text" class="form-control" style="width: 50px; margin-left: 8px; border-right: none; border-top-right-radius: 0; border-bottom-right-radius: 0;"
                v-model="supplier.payment_terms_days"
              >
              <span class="input-group-text" style="border-top-left-radius: 0; border-bottom-left-radius: 0; margin-right: 8px; height: 40px;">Tagen</span>
              <span>ab Rechnung</span>
            </div>
          </div>
          <div class="form-group has-label">
            <label>Skonto</label>
            <div class="d-flex align-items-center">
              <input type="text" class="form-control" style="width: 50px; border-right: none; border-top-right-radius: 0; border-bottom-right-radius: 0;"
                v-model="supplier.skonto_percent"
              >
              <span class="input-group-text" style="border-top-left-radius: 0; border-bottom-left-radius: 0; margin-right: 8px; height: 40px;">%</span>
              <span>Skonto bei Zahlungen binnen</span>
              <input type="text" class="form-control" style="width: 50px; margin-left: 8px; border-right: none; border-top-right-radius: 0; border-bottom-right-radius: 0;"
                v-model="supplier.skonto_days"
              >
              <span class="input-group-text" style="border-top-left-radius: 0; border-bottom-left-radius: 0; margin-right: 8px; height: 40px;">Tagen</span>
            </div>
          </div>
          <div class="form-group has-label">
            <label>Anzahlung</label>
            <div class="d-flex align-items-center">
              <input type="text" class="form-control" style="width: 50px; border-right: none; border-top-right-radius: 0; border-bottom-right-radius: 0;"
                v-model="supplier.prepayment_percent"
              >
              <span class="input-group-text" style="border-top-left-radius: 0; border-bottom-left-radius: 0; margin-right: 8px; height: 40px;">%</span>
            </div>
          </div>
        </div>
      </div>
      <button type="submit" class="btn btn-fill btn-info">{{ submitText }}</button>
    </form>
  </card>
</template>

<script>
import countries from './../../countries'
import priceWatcher from 'src/pages/Products/price-watcher'

export default {
  props: ['valErrors', 'initSupplier', 'submitText'],
  mixins: [priceWatcher],
  data () {
    return {
      supplier: this.initSupplier,
      countries,
      supplierCategories: [],
      supplierTags: []
    }
  },
  methods: {
    allowZeroPrice () {
      return true
    },
    submit () {
      this.supplier.supplier_category_id = this.supplier.category ? this.supplier.category.id : null
      this.$emit('submit', this.supplier)
    },
    getPrice () {
      return this.supplier.min_order_sum
    },
    setPrice (minOrderSum) {
      this.supplier.min_order_sum = minOrderSum
    }
  },
  created () {
    this.$http.get(`/supplier_tags`).then(({ data }) => {
      this.supplierTags = data
    })
    this.$http.get('/supplier_categories').then(({ data }) => { this.supplierCategories = data })
  }
}
</script>

<style>
</style>
